import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import {
  GenericLinkModule,
  MediaModule,
  NonReturnableModule,
  PipesModule,
  PrincipalConfigurationDirectiveModule,
  ReadMoreModule,
} from '../../../../shared';
import { BadgeModule } from '../../../../shared/components/badge';
import { NotificationModule } from '../../../../shared/components/notification';
import { PdpInquiryModalModule } from '../pdp-inquiry-modal/pdp-inquiry-modal.module';
import { PdpOverviewComponent } from './pdp-overview.component';

@NgModule({
  declarations: [PdpOverviewComponent],
  exports: [PdpOverviewComponent],
  imports: [
    CommonModule,
    NzIconModule,
    I18nModule,
    MediaModule,
    PipesModule,
    NgbTooltipModule,
    NonReturnableModule,
    GenericLinkModule,
    NotificationModule,
    BadgeModule,
    ReadMoreModule,
    PrincipalConfigurationDirectiveModule,
    PdpInquiryModalModule,
  ],
  providers: [],
})
export class PdpOverviewModule {}
